import React, { useState } from 'react';
import { motion } from 'framer-motion';

const CORRECT_PASSWORD = import.meta.env.VITE_WEDDING_PASSWORD || '';

interface PasswordProps {
  onAuthenticated: () => void;
}

const Login: React.FC<PasswordProps> = ({ onAuthenticated }) => {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    
    if (password === CORRECT_PASSWORD) {
      sessionStorage.setItem('wedding-authenticated', 'true');
      setError('');
      onAuthenticated();
    } else {
      setError('Incorrect password. Please try again.');
      setPassword('');
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-cream via-white to-blush flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="bg-white/90 backdrop-blur-sm shadow-lg rounded-lg p-8 text-center mb-8"
        >
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.3 }}
            className="mb-8"
          >
            <h1 className="main-heading text-charcoal">Cat</h1>
            <div className="script-heading text-gold my-2">&</div>
            <h1 className="main-heading text-charcoal">Rich</h1>
            <div className="elegant-divider"></div>
          </motion.div>
          
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.6 }}
            className="small-text mb-6"
          >
            "The wedding of the century..." - Cat Keaney, 2025
          </motion.p>
        </motion.div>

        <motion.form
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.9 }}
          onSubmit={handleSubmit}
          className="space-y-4"
        >
          <div className="w-full flex justify-center">
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Password"
              className="w-3/4 p-3 text-center body-text border border-gray-300 rounded focus:outline-none focus:border-gold placeholder:text-center"
              autoFocus
            />
          </div>

          {error && (
            <p className="text-red-500 small-text text-center">{error}</p>
          )}
          <div className="w-full flex justify-center">
            <button
              type="submit"
              className="w-1/5 text-center text-charcoal hover-text-gold transition-colors duration-300 button-text tracking-wider bg-transparent py-3"
            >
              Enter
            </button>
          </div>
        </motion.form>
      </div>
    </div>
  );
};

export default Login;